// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%2364748b%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Currency Pair Management – list/table only */
.currency-pair-page .dashboard-body {
  width: 100%;
}

.currency-pair-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 5rem;
  overflow: visible;
}

.currency-pair-hero .dashboard-hero__text {
  padding-bottom: 0.25rem;
}

.currency-pair-hero .dashboard-hero__subtitle {
  line-height: 1.5;
  margin: 0;
}

.currency-pair-hero__actions {
  display: flex;
  gap: 0.75rem;
}

.cp-btn--add {
  white-space: nowrap;
}

.currency-pair-card--table-only {
  padding: 1.5rem;
}

.currency-pair-hero__icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  font-size: 1.35rem;
  color: #fff;
}

.currency-pair-body {
  padding-bottom: 2rem;
}

.currency-pair-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* Section headers */
.currency-pair-section-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1.25rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
}

.currency-pair-section-head i {
  color: #0f766e;
  font-size: 1.1rem;
  width: 1.25rem;
  text-align: center;
}

/* Add Coins form */
.currency-pair-add-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cp-field {
  margin-bottom: 0;
}

.cp-field label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text);
}

.cp-field .required {
  color: #dc2626;
}

.cp-input-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0 1rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: border-color 0.2s;
}

.cp-input-wrap:focus-within {
  border-color: #0f766e;
  box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.15);
}

.cp-input-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
  flex-shrink: 0;
}

.cp-input-wrap input,
.cp-input-wrap select {
  flex: 1 1;
  min-width: 0;
  padding: 0.65rem 0;
  font-size: 0.9rem;
  font-family: inherit;
  border: none;
  background: none;
  color: var(--text);
}

.cp-input-wrap input::placeholder,
.cp-input-wrap select option[value=""] {
  color: var(--text-muted);
}

.cp-input-wrap select {
  cursor: pointer;
  appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 0.75rem center;
  padding-right: 2rem;
}

/* Radio groups */
.cp-field--row .cp-radio-group {
  width: 100%;
}

.cp-radio-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text);
}

.cp-radio-icon {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.cp-radio-wrap {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.cp-radio-wrap label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text);
  cursor: pointer;
  margin: 0;
}

.cp-radio-wrap input[type="radio"] {
  accent-color: #0f766e;
}

/* File upload */
.cp-file-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cp-file-icon {
  color: var(--text-muted);
  font-size: 1rem;
}

.cp-file-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  position: absolute;
}

.cp-file-btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  background: #f1f5f9;
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.cp-file-btn:hover {
  background: #e2e8f0;
}

.cp-file-text {
  font-size: 0.85rem;
  color: var(--text-muted);
}

/* Buttons */
.cp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.cp-btn--submit,
.cp-btn--primary {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);
  margin-top: 0.5rem;
  width: 100%;
  max-width: 100%;
}

.cp-btn--submit:hover,
.cp-btn--primary:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

.cp-btn--export {
  background: #fff;
  color: var(--text);
  border: 1px solid var(--border);
}

.cp-btn--export:hover {
  background: #f8fafc;
}

.cp-btn--outline {
  background: #fff;
  color: var(--text);
  border: 1px solid var(--border);
}

.cp-btn--outline:hover {
  background: #f8fafc;
}

.cp-btn--danger {
  background: #dc2626;
  color: #fff;
}

.cp-btn--danger:hover {
  background: #b91c1c;
}

.cp-btn--primary:focus-visible,
.cp-btn--submit:focus-visible {
  outline: 2px solid #0f766e;
  outline-offset: 2px;
}

/* Stepper */
.cp-stepper {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.cp-stepper-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-muted);
}

.cp-stepper-item.active {
  color: #0f766e;
  font-weight: 600;
}

.cp-stepper-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e2e8f0;
  color: var(--text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
}

.cp-stepper-item.active .cp-stepper-num {
  background: #0f766e;
  color: #fff;
}

.cp-stepper-line {
  width: 24px;
  height: 2px;
  background: #e2e8f0;
  margin: 0 0.25rem;
}

.cp-step-desc {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  color: var(--text-muted);
}

/* Table block */
.currency-pair-table-block {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.currency-pair-table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.currency-pair-table-head .currency-pair-section-head {
  margin-bottom: 0;
}

.cp-table-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.cp-filter-wrap {
  display: flex;
  align-items: center;
}

.cp-filter-select {
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}

.cp-list-error {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  margin-bottom: 1rem;
  background: #fef2f2;
  color: #b91c1c;
  border-radius: 8px;
  font-size: 0.9rem;
}

.cp-list-error .cp-btn--sm {
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
}

.cp-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 3rem;
  color: var(--text-muted);
  font-size: 0.95rem;
}

.cp-export-wrap {
  position: relative;
}

.cp-export-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.25rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 0.35rem;
  z-index: 10;
  min-width: 120px;
}

.cp-export-dropdown button {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  font-family: inherit;
}

.cp-export-dropdown button:hover {
  background: #f1f5f9;
}

.cp-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.6rem 1rem;
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 1rem;
  max-width: 280px;
}

.cp-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.cp-search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: none;
  font-size: 0.9rem;
  font-family: inherit;
  color: var(--text);
}

.cp-search-input::placeholder {
  color: var(--text-muted);
}

.cp-search-input:focus {
  outline: none;
}

/* Table */
.cp-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
  flex: 1 1;
  min-height: 0;
}

.cp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.cp-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.4;
  color: var(--text-muted);
  background: #f8fafc;
  border-bottom: 2px solid var(--border);
  white-space: nowrap;
}

.cp-table td {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #f1f5f9;
}

.cp-table tbody tr:last-child td {
  border-bottom: none;
}

.cp-table tbody tr:hover {
  background: #fafafa;
}

/* Badges */
.cp-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.cp-badge--global {
  background: #dcfce7;
  color: #166534;
}

.cp-badge--local {
  background: #fef3c7;
  color: #92400e;
}

.cp-badge i {
  font-size: 0.7rem;
}

/* Action buttons in table */
.cp-action-btns {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.cp-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.cp-action-btn:hover {
  opacity: 0.9;
}

.cp-action-btn--delete {
  background: #fef2f2;
  color: #b91c1c;
}

.cp-action-btn--list {
  background: #dcfce7;
  color: #166534;
}

.cp-action-btn--delist {
  background: #fef3c7;
  color: #92400e;
}

/* Pagination */
.cp-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 0 0;
  margin-top: 1rem;
  border-top: 1px solid #f1f5f9;
}

.cp-pagination-rows {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.cp-pagination-rows select {
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}

.cp-pagination-info {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.cp-pagination-nav {
  display: flex;
  gap: 0.25rem;
}

.cp-pagination-btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: var(--text);
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.cp-pagination-btn:hover:not(:disabled) {
  background: #f1f5f9;
}

.cp-pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modals */
.cp-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.cp-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 465px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.cp-modal h3 {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
}

.cp-modal p {
  margin: 0 0 1.25rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.cp-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

/* Responsive */
@media (max-width: 768px) {
  .currency-pair-hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .currency-pair-table-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .cp-stepper {
    flex-direction: column;
    align-items: flex-start;
  }

  .cp-stepper-line {
    width: 2px;
    height: 16px;
    margin: 0 0 0 13px;
  }

  .cp-pagination {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/CurrencyPairManagementPage.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kFAAmN;EACnN,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;;EAEE,6DAA6D;EAC7D,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Currency Pair Management – list/table only */\n.currency-pair-page .dashboard-body {\n  width: 100%;\n}\n\n.currency-pair-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-bottom: 5rem;\n  overflow: visible;\n}\n\n.currency-pair-hero .dashboard-hero__text {\n  padding-bottom: 0.25rem;\n}\n\n.currency-pair-hero .dashboard-hero__subtitle {\n  line-height: 1.5;\n  margin: 0;\n}\n\n.currency-pair-hero__actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.cp-btn--add {\n  white-space: nowrap;\n}\n\n.currency-pair-card--table-only {\n  padding: 1.5rem;\n}\n\n.currency-pair-hero__icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 12px;\n  font-size: 1.35rem;\n  color: #fff;\n}\n\n.currency-pair-body {\n  padding-bottom: 2rem;\n}\n\n.currency-pair-card {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n/* Section headers */\n.currency-pair-section-head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-bottom: 1.25rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.currency-pair-section-head i {\n  color: #0f766e;\n  font-size: 1.1rem;\n  width: 1.25rem;\n  text-align: center;\n}\n\n/* Add Coins form */\n.currency-pair-add-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.cp-field {\n  margin-bottom: 0;\n}\n\n.cp-field label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.cp-field .required {\n  color: #dc2626;\n}\n\n.cp-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0 1rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  transition: border-color 0.2s;\n}\n\n.cp-input-wrap:focus-within {\n  border-color: #0f766e;\n  box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.15);\n}\n\n.cp-input-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  flex-shrink: 0;\n}\n\n.cp-input-wrap input,\n.cp-input-wrap select {\n  flex: 1;\n  min-width: 0;\n  padding: 0.65rem 0;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: none;\n  background: none;\n  color: var(--text);\n}\n\n.cp-input-wrap input::placeholder,\n.cp-input-wrap select option[value=\"\"] {\n  color: var(--text-muted);\n}\n\n.cp-input-wrap select {\n  cursor: pointer;\n  appearance: none;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M6 8L1 3h10z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n  padding-right: 2rem;\n}\n\n/* Radio groups */\n.cp-field--row .cp-radio-group {\n  width: 100%;\n}\n\n.cp-radio-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.cp-radio-icon {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.cp-radio-wrap {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.cp-radio-wrap label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text);\n  cursor: pointer;\n  margin: 0;\n}\n\n.cp-radio-wrap input[type=\"radio\"] {\n  accent-color: #0f766e;\n}\n\n/* File upload */\n.cp-file-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.cp-file-icon {\n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n.cp-file-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  position: absolute;\n}\n\n.cp-file-btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  background: #f1f5f9;\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.cp-file-btn:hover {\n  background: #e2e8f0;\n}\n\n.cp-file-text {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n/* Buttons */\n.cp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.cp-btn--submit,\n.cp-btn--primary {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);\n  margin-top: 0.5rem;\n  width: 100%;\n  max-width: 100%;\n}\n\n.cp-btn--submit:hover,\n.cp-btn--primary:hover {\n  opacity: 0.95;\n  transform: translateY(-1px);\n}\n\n.cp-btn--export {\n  background: #fff;\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.cp-btn--export:hover {\n  background: #f8fafc;\n}\n\n.cp-btn--outline {\n  background: #fff;\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.cp-btn--outline:hover {\n  background: #f8fafc;\n}\n\n.cp-btn--danger {\n  background: #dc2626;\n  color: #fff;\n}\n\n.cp-btn--danger:hover {\n  background: #b91c1c;\n}\n\n.cp-btn--primary:focus-visible,\n.cp-btn--submit:focus-visible {\n  outline: 2px solid #0f766e;\n  outline-offset: 2px;\n}\n\n/* Stepper */\n.cp-stepper {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.cp-stepper-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.cp-stepper-item.active {\n  color: #0f766e;\n  font-weight: 600;\n}\n\n.cp-stepper-num {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  color: var(--text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.cp-stepper-item.active .cp-stepper-num {\n  background: #0f766e;\n  color: #fff;\n}\n\n.cp-stepper-line {\n  width: 24px;\n  height: 2px;\n  background: #e2e8f0;\n  margin: 0 0.25rem;\n}\n\n.cp-step-desc {\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n/* Table block */\n.currency-pair-table-block {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.currency-pair-table-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.currency-pair-table-head .currency-pair-section-head {\n  margin-bottom: 0;\n}\n\n.cp-table-actions {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.cp-filter-wrap {\n  display: flex;\n  align-items: center;\n}\n\n.cp-filter-select {\n  padding: 0.5rem 2rem 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.cp-list-error {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  border-radius: 8px;\n  font-size: 0.9rem;\n}\n\n.cp-list-error .cp-btn--sm {\n  padding: 0.4rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n.cp-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 3rem;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n.cp-export-wrap {\n  position: relative;\n}\n\n.cp-export-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.25rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 0.35rem;\n  z-index: 10;\n  min-width: 120px;\n}\n\n.cp-export-dropdown button {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  font-size: 0.85rem;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n  font-family: inherit;\n}\n\n.cp-export-dropdown button:hover {\n  background: #f1f5f9;\n}\n\n.cp-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.6rem 1rem;\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  max-width: 280px;\n}\n\n.cp-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.cp-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  font-size: 0.9rem;\n  font-family: inherit;\n  color: var(--text);\n}\n\n.cp-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.cp-search-input:focus {\n  outline: none;\n}\n\n/* Table */\n.cp-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  flex: 1;\n  min-height: 0;\n}\n\n.cp-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.cp-table th {\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.4;\n  color: var(--text-muted);\n  background: #f8fafc;\n  border-bottom: 2px solid var(--border);\n  white-space: nowrap;\n}\n\n.cp-table td {\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.cp-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.cp-table tbody tr:hover {\n  background: #fafafa;\n}\n\n/* Badges */\n.cp-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.cp-badge--global {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.cp-badge--local {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.cp-badge i {\n  font-size: 0.7rem;\n}\n\n/* Action buttons in table */\n.cp-action-btns {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.cp-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.cp-action-btn:hover {\n  opacity: 0.9;\n}\n\n.cp-action-btn--delete {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.cp-action-btn--list {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.cp-action-btn--delist {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n/* Pagination */\n.cp-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 0 0;\n  margin-top: 1rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.cp-pagination-rows {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.cp-pagination-rows select {\n  padding: 0.4rem 0.6rem;\n  font-size: 0.85rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.cp-pagination-info {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.cp-pagination-nav {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.cp-pagination-btn {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  color: var(--text);\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.cp-pagination-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.cp-pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Modals */\n.cp-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.cp-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 465px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.cp-modal h3 {\n  margin: 0 0 0.75rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.cp-modal p {\n  margin: 0 0 1.25rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.cp-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .currency-pair-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .currency-pair-table-head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .cp-stepper {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .cp-stepper-line {\n    width: 2px;\n    height: 16px;\n    margin: 0 0 0 13px;\n  }\n\n  .cp-pagination {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
